const translations = {
  "login.Title": "სისტემაში შესვლა",
  "login.Username": "მომხმარებლის სახელი",
  "login.Password": "პაროლი",
  "login.UserNotFound": "მომხმარებელი / პაროლი არასწორია!",
  "login.Login": "შესვლა",
  "login.RememberMe": "დამახსოვრება",
  "login.ForgotPassword": "დაგავიწყდათ პაროლი?",
  "USER_PASS_INCORRECT": "მომხმარებელი / პაროლი არასწორია!"
};

export default translations;
